import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatexPipe } from './DatexPipe';
import * as moment from 'moment';
import { utils, write, WorkBook } from 'xlsx';
import { NgbTimeStruct, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
// import { MessageServices } from './message.services';
// import { HeaderComponent } from '../../core'

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  showError: any;

  constructor(private spinner: NgxSpinnerService, private datePipe: DatexPipe) { }


  // sessionCheck(message) {
  //   //  console.log(message)
  //   let session = message.sessionData
  //   if(session != undefined){
  //     if(session.code == "9999"){
  //         this.message.errorText("User Session Invalid, Login again")
  //         // this.header.logout()
  //     }else{

  //     }

  //   }else{

  //   }
  // }

  startLoader() {
    this.spinner.show();
  }

  stopLoader() {
    this.spinner.hide();
  }

  convertDateFromString(string) {
    return moment(string).format('YYYY-MM-DD')
  }

  convertTimeStamp(v) {
    if (v !== null) {
      var d = new Date(v)
      return this.addZero(d.getDate()) + '/' + this.addZero((d.getMonth() + 1)) + '/' + d.getFullYear();
    } else {
      return ''
    }
  }

  splitDate(d) {
    let r = d.split('/')
    return r[0]
  }

  splitMonth(d) {
    let r = d.split('/')
    return r[1]
  }

  splitYear(d) {
    let r = d.split('/')
    return r[2]
  }


  // dateDiffer(a){
  //   let b = new Date();
  //   let dateTo = new Date(this.convertTimeStamp(a));
  //   let dateFrom = new Date( (b.getMonth() +1)+ '/' + b.getDate()  + '/' + b.getFullYear());
  //   const differ = Math.abs(dateFrom - dateTo);
  // }


  calculateDiff(dateSent) {
    let currentDate = new Date();
    dateSent = new Date(dateSent);
    let differ = Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate())) / (1000 * 60 * 60 * 24));
    if (differ < 7) {
      return false
    } else {
      return true
    }
  }

  addZero(i) {
    if (i < 10) {
      i = '0' + i
    }
    return i
  }

  convertTimeStampWithTime(d) {
    if (d !== null) {
      var t = new Date(d);
      return t.getDate() + '/' + (t.getMonth() + 1) + '/' + t.getFullYear() + ' ' + this.addZero(t.getHours()) + ':' + this.addZero(t.getMinutes()) + ':' + this.addZero(t.getSeconds())
    } else {
      return ''
    }
  }

  convertTimeStampWithTime_Latest(d) {
    if (d !== null) {
      var t = new Date(d)
      return t.getDate() + '-' + (t.getMonth() + 1) + '-' + t.getFullYear() + ' ' + this.addZero(t.getHours()) + ':' + this.addZero(t.getMinutes()) + ':' + this.addZero(t.getSeconds())
    } else {
      return ''
    }
  }

  convertLongToDate(d) {
    if (d !== null) {
      var t = new Date(d)
      return t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate() + ' ' + this.addZero(t.getHours()) + ':' + this.addZero(t.getMinutes()) + ':' + this.addZero(t.getSeconds())
    } else {
      return ''
    }
  }

  convertTimeStamp_Dash(d) {
    if (d !== null) {
      var t = new Date(d)
      return ('0' + t.getDate()).slice(-2) + '-' + ('0' + (t.getMonth() + 1)).slice(-2) + '-' + t.getFullYear()
    } else {
      return ''
    }
  }

  convertTimestamp_Time(d) {
    if (d !== null) {
      var t = new Date(d)
      return this.addZero(t.getHours()) + ':' + this.addZero(t.getMinutes()) + ':' + this.addZero(t.getSeconds())
    } else {
      return ''
    }
  }

  getShift(d) {
    if (d !== null) {
      let os = '07:00:00'
      let oe = '15:29:59'
      let ts = '15:30:00'
      let te = '23:59:59'
      let hs = '00:00:00'
      let he = '06:59:59'

      if (os < d && d < oe) {
        return '1st Shift';
      }
      if (ts < d && d < te) {
        return '2nd Shift';
      }
      if (hs < d && d < he) {
        return '3rd Shift';
      }
    } else {
      return ''
    }

  }


  // ('0' + d.hour).slice(-2)

  getDisplayDateFormat(date: any) {
    let formdateDate = this.datePipe.transform(date, "DD-MM-YYYY");
    return formdateDate
  }

  getCalendarFormattedDate(date: any): any {
    let format = [date.year, date.month, date.day].join('/');
    return format;
  }

  getSearchFormattedDate(date: any): any {
    if (date !== null) {
      var num = date.day;
      var mon = date.month;
      if (num < 10) {
        num = "0" + num;
        //console.log("N-----" + num)
      }
      if (mon < 10) {
        mon = "0" + mon
      }
      let format = [date.year, mon, num].join('-');
      //let format = this.datePipe.transform(date, "yyyy-MM-dd");
      return format;
    } else {
      return null
    }
  }

  changeTimepickerFormat(d: any): any {
    if (d !== null) {
      let c = ('0' + d.hour).slice(-2) + ':' + ('0' + d.minute).slice(-2) + ':' + ('0' + d.second).slice(-2)
      return c
    } else {
      return null
    }
  }

  unchangeTimepickerFormat(d: any): any {
    if (d !== null) {
      let h = d.split(":");
      let data: NgbTimeStruct = { hour: parseInt(h[0]), minute: parseInt(h[1]), second: parseInt(h[2]) }
      // data.hour= parseInt(h[0]);
      // data.minute = h[1];
      // data.second = h[2];
      return data
    } else {
      return null
    }
  }

  setDatePicker(date: any): any {
    if (date != null) {
      let formdateDate = this.datePipe.transform(date, "YYYY-MM-DD");
      let temp = formdateDate.split("-")
      let data: NgbDateStruct = { "year": parseInt(temp[0]), "month": parseInt(temp[1]), "day": parseInt(temp[2]) }
      return data
    } else {
      return null
    }
  }



  getNormalFormattedData(date: any): any {
    var num = date.day;
    var mon = date.month;
    if (num < 10) {
      num = "0" + num;
    }
    if (mon < 10) {
      mon = "0" + mon
    }
    let format = [num, mon, date.year].join('-');
    //let format = this.datePipe.transform(date, "dd-MM-yyy");
    return format;
  }

  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    };
    return buf;
  }
  generateExcelFile(data): any {
    const ws_name = 'SomeSheet';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(data);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    return wbout;
  }

  generateExcelFileWithCustom(data, sheet): any {
    const ws_name = sheet;
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(data);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    return wbout;
  }





  getServerDateFormat(date: any) {
    let formdateDate = this.datePipe.transform(date, "YYYY-MM-DD");
    console.log(JSON.stringify(date.year))
    return formdateDate

  }

  getCustomServerDate(date: any) {
    let formatDate = date.year + '-' + ('0' + date.month).slice(-2) + '-' + ('0' + date.day).slice(-2)
    return formatDate;
  }

  isDateGreaterThanDayOrSame(startDate, endDate) {
    let start = this.datePipe.transform(new Date(startDate), "YYYY-MM-DD");
    let end = this.datePipe.transform(new Date(endDate), "YYYY-MM-DD");
    return moment(end).isSameOrAfter(start, 'day');
  }

  timestampDiffer(a) {
    let hh;
    let mm;
    a = a / 1000
    hh = Math.floor(a / 3600)
    mm = Math.floor(a % 3600 / 60)
    //var ss = Math.floor(a /60 /60)
    var ss = Math.floor(a - (hh * 3600) - (mm * 60));
    //var ss = Math.round(s * 100) / 100; 
    // console.log(ss)
    // console.log(mm)
    //let differ = ('0'+hh).slice(-2) + ':' +('0'+mm).slice(-2) + ':' +('0'+ss).slice(-2);

    if (hh <= 9) {
      hh = '0' + hh
    }
    if (mm <= 9) {
      mm = '0' + mm
    }
    let differ = hh + ':' + mm;
    return differ
  }

  configtime(a) {
    let b: any = ["04", "00", "00"]
    let second = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
    let second1 = (+b[0]) * 60 * 60 + (+b[1]) * 60 + (+b[2]);
    if (second > second1) {
      return true
    } else if (second < second1) {
      return false
    } else {
      return false
    }
  }

  stringToDate(data) {
    if (data !== null) {
      let splitData = data.split("-")
      return parseInt(splitData[0]) + "-" + ('0' + parseInt(splitData[1])).slice(-2) + "-" + parseInt(splitData[2])
    } else {
      return null
    }

  }


  getDistanceInKm(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the earth in km
    var dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = this.deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2)
      ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  }

  deg2rad(deg) {
    return deg * (Math.PI / 180)
  }


  getDownloadDateFormat(date: any) {
    let formdateDate = this.datePipe.transform(date, "DDMMYYYY");
    return formdateDate
  }

  ExcelDateToJSDateServer(date: any) {
    if (date !== null) {
      var utc_days = Math.floor(date - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);
      var d = new Date(date_info),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;
      return [year, month, day].join('-');
    } else {
      return null
    }

  }


  ExcelDateToJSDateShow(date: any) {
    if (date !== null) {
      var utc_days = Math.floor(date - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);

      var d = new Date(date_info),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;
      return [day, month, year].join('-');
    } else {
      return null
    }

  }


  ExcelDateToJSDateShowCmpare(date: any) {
    //console.log(date)
    if (date !== null || date == "" || date == undefined) {
      var utc_days = Math.floor(date - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);

      var d = new Date(date_info),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;
      return [year, month, day].join('-');
    } else {
      return null
    }

  }

  ChangedExcelDateToJSDateShowCmpare(date: any) {
    if (date !== null) {
      var utc_days = Math.floor(date - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);

      var d = new Date(date_info),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;
      // return [day, month, year].join('-');
      return [year, month, day].join('-');
    } else {
      return null
    }

  }


  public compareDate(date1: Date, date2: Date): Boolean {
    let d1 = new Date(date1); let d2 = new Date(date2);


    let same = d1.getTime() === d2.getTime();
    if (same) {

      return false
    }

    if (d1 > d2) {
      return true;
    }
    if (d1 < d2) {

      return false;
    }


  }

  truckConcat(i, j, k, l) {
    return i + j + k + l
  }

  // configtime(a,b){
  //  a = a/1000
  //  let hms = b.split(':');
  //  let second = (+hms[0]) * 60 * 60 + (+hms[1]) * 60 + (+hms[2]);
  //  if(second > a){
  //       return false
  //  }else if(second < a){
  //       return true
  //  }else{
  //    return false
  //  }
  // }

  clearAllLocalStorage() {
    localStorage.removeItem('userLoggedin');
    localStorage.removeItem('user_id')
    localStorage.removeItem('role_id')
    localStorage.removeItem('name')
    localStorage.removeItem('email')
    localStorage.removeItem('Dealer_code')
    localStorage.removeItem('transporterCode')
    localStorage.removeItem('role_desc');
    localStorage.removeItem('transSubmit')
    localStorage.removeItem('screen')
    localStorage.removeItem('Obl_code')
    localStorage.removeItem('statusList')
    localStorage.removeItem('brand')
    //localStorage.clear();
    localStorage.clear();
  }


  // Alert Component

  // errorAlert(text) {
  // 	this.alerts.error(text, 3000);
  // }

  // successAlert(text) {
  // 	this.alerts.success(text, 3000)
  // }
  // warningAlert(text) {
  // 	this.alerts.warn(text, 3000)
  // }
  // infoAlert(text) {
  // 	this.alerts.info(text, 3000)
  // }

  // errorToast(text){
  // 	this.alerts.errorToast(text);
  // }
  // successToast(text){
  // 	this.alerts.successToast(text);
  // }

}
